import script from "./team.vue?vue&type=script&setup=true&lang=js"
export * from "./team.vue?vue&type=script&setup=true&lang=js"

import "./team.vue?vue&type=style&index=0&id=061b86ee&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-061b86ee"]])

export default __exports__